import { ProcessingJobs as WorkspaceProcessingJobs } from '../administration/processing';

const Processing = () => <WorkspaceProcessingJobs />;

export default Processing;

